<template>
  <div id="App">
    <Navblock :siteMeta="siteMeta" />
    <main class="content">
      <transition name="fade-in" mode="out-in">
        <router-view :siteMeta="siteMeta" :projectsMeta="projects" :key="this.$route.path"></router-view>
      </transition>
    </main>
  </div>
</template>

<script>
import Navblock from './components/Navblock.vue';

/**
 * Maps API data from Strapi to usable fields 
 */
function parseProjectData(projectData) {
  return {
    title:            projectData.title,
    date:             projectData.date && new Date(projectData.date).getFullYear(),
    description:      projectData.description,
    short_description:projectData.short_description,
    cover_image:      projectData.cover_image && parseImageGroup(projectData.cover_image) || projectData.carousel_images[0] && parseImageGroup(projectData.carousel_images[0]),
    poster_image:     projectData.poster_image && parseImageGroup(projectData.poster_image),
    carousel_images:  projectData.carousel_images.length > 0 && projectData.carousel_images.map(image => parseImageGroup(image)) || [parseImageGroup(projectData.cover_image)],
    type:             projectData.type,
    kind:             projectData.kind,
    tags:             projectData.tags,
    team:             projectData.team,
    role:             projectData.role,
    github_url:       projectData.github_url, 
    website_url:      projectData.website_url, 
    order:            projectData.order && parseInt(projectData.order),
  }
}

/**
 * Maps API data from Strapi:GroupRichImage to simple image 
 */
function parseImageGroup(imageGroup) {
  if(!imageGroup) return false; 
  return {
    src:        imageGroup.base_image && imageGroup.base_image.url,
    alt:        imageGroup.alt,
    ratio:      imageGroup.base_image && parseInt(imageGroup.base_image.size),
    mime:       imageGroup.base_image && imageGroup.base_image.mime,
    name:       imageGroup.base_image && imageGroup.base_image.name,
    ext:        imageGroup.base_image && imageGroup.base_image.ext,
    id:         imageGroup.base_image && imageGroup.base_image.id 
  }
}

/**
 * Sort API data from Strapi
 */
const sortBy = (a, b) => {
  // const year = d => d.split(' ')[1]
  // return new Date(b.date) - new Date(a.date)
  console.log(a.title, a.order, b.order);
  return parseInt(a.order) < parseInt(b.order)
}; 

export default {
  props: ['siteMeta', 'projectsMeta'], 
  name: 'App',
  components: {
    Navblock
  },
  data() {
    return {
      mobileWidth: 768
    }
  },
  computed: {
    projects() {
      let filteredProjects  = this.projectsMeta.filter(p => p.active); 
      let sortedProjects    = filteredProjects && filteredProjects.map(a => a).sort((a, b) => a.order - b.order);
      return sortedProjects && sortedProjects.map(proj => parseProjectData(proj))
    }
  },
  mounted() {
    console.log(`%c Hello! Any questions? Find this project on my github! ;)`,
    "font-family: 'titling-gothic-fb', Helvetica, sans-serif; font-size: 14px; padding: 10px 10px 10px 0px; font-weight: 400; color: #34ae15");
  }
}
</script>
